module.exports = __webpack_public_path__ + "static/media/Sung-Icon-2.5a2e76bc.svg";